export default "__VITE_ASSET__BgtB7O6e__"